import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingFarmPrimaryData, setFootprintingFarmPrimaryDataAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM, FOOTPRINTING_FARM_CALCULATED_FOOTPRINT, FOOTPRINTING_FARM_PRIMARY_DATA, FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN } from "consts";

import { FootprintingFarmPrimaryData } from "models";

export const useMutateFootprintingFarmPrimaryData = (
  farmId: string,
  year: number,
  payload: Omit<FootprintingFarmPrimaryData, "id">,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? setFootprintingFarmPrimaryDataAdmin : setFootprintingFarmPrimaryData;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_PRIMARY_DATA, primaryDataId],
      mutationFn: () => queryFn(payload, primaryDataId ?? ""),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_FARM_PRIMARY_DATA, primaryDataId],
          [FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN, primaryDataId],
          [FOOTPRINTING_FARM_CALCULATED_FOOTPRINT, primaryDataId],
          [FOOTPRINTING_FARM_PRIMARY_DATA, farmId, year],
          [FOOTPRINTING_FARM_CALCULATED_FOOTPRINT, farmId, year],
          [FOOTPRINTING_FARM, farmId, year],
          [FOOTPRINTING_FARM, primaryDataId, isAdmin],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
